// extracted by mini-css-extract-plugin
export var box = "_4h-2";
export var checkboxControl = "_4h-0";
export var checkboxRow = "_4h-a";
export var checked = "_4h-3";
export var descriptionSpacer = "_4h-c";
export var disabled = "_4h-4";
export var icon = "_4h-8";
export var input = "_4h-1";
export var labelSpacer = "_4h-b";
export var large = "_4h-7";
export var medium = "_4h-6";
export var small = "_4h-5";
export var text = "_4h-9";